module.exports = __webpack_public_path__ + "media/images/New_Photography_Project-88d0ea49.png";